import { render, staticRenderFns } from "./ImageItem.vue?vue&type=template&id=54cc24ad&scoped=true"
import script from "./ImageItem.vue?vue&type=script&lang=js"
export * from "./ImageItem.vue?vue&type=script&lang=js"
import style0 from "./ImageItem.vue?vue&type=style&index=0&id=54cc24ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cc24ad",
  null
  
)

export default component.exports